/* REVIV Sticky PDP Add-to-Cart Bar — Variant B v2.1 (production)
 * Markup lives in snippets/reviv-sticky-bar.liquid, styles in reviv-sticky-bar.css.
 * This file only wires behaviour: price mirror, qty sync, ATC proxy, show/hide.
 */
(function () {
  'use strict';

  if (window.__revivStickyBarInit) return;

  var bar = document.getElementById('reviv-sticky-bar');
  if (!bar) return; // snippet not rendered on this page

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return (root || document).querySelectorAll(sel); }

  function isVisible(el) {
    if (!el) return false;
    if (el.getAttribute && el.getAttribute('aria-hidden') === 'true') return false;
    if (el.offsetParent === null && el.getClientRects().length === 0) return false;
    var cs;
    try { cs = window.getComputedStyle(el); } catch (e) { return true; }
    if (!cs) return true;
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  /* --- resolve native theme elements -------------------------------------- */
  function getEls() {
    var form = q('#c_productform') || q('form[action^="/cart/add"]') || q('form.shopify-product-form');
    var scope = form || document;
    var atc = q('.addtocartbtn', scope) || q('.main-product__addtocard-btn', scope) || q('[type="submit"]', scope);
    var qty = q('#qtynumber', scope) || q('input[name="quantity"]', scope);
    var currentPrice = q('.prod-main-price') || q('.main-product__total .prod-main-price') || q('.price__current');
    var anchor = q('.main-product__addtocard') || q('.main-product__total') || atc;
    return {
      form: form, atc: atc, qty: qty,
      qtyMinus: q('#qty-minus'), qtyPlus: q('#qty-plus'),
      currentPrice: currentPrice, priceBlock: q('.main-product__total'), anchor: anchor
    };
  }

  function whenDomReady(cb) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cb);
    else cb();
  }

  function waitFor(testFn, cb, timeoutMs) {
    var start = Date.now();
    var hit = testFn();
    if (hit) { cb(hit); return; }
    var iv = setInterval(function () {
      var r = testFn();
      if (r) { clearInterval(iv); cb(r); return; }
      if (Date.now() - start > timeoutMs) clearInterval(iv);
    }, 120);
  }

  whenDomReady(function () {
    waitFor(function () { var e = getEls(); return (e.form && e.atc) ? e : null; }, init, 8000);
  });

  /* ======================================================================== */
  function init(els) {
    if (window.__revivStickyBarInit) return;
    window.__revivStickyBarInit = true;

    var reduceMotion = false;
    try { reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (reduceMotion) bar.classList.add('reviv-sticky--no-anim');

    var elPrice = q('.reviv-sticky__price', bar);
    var elQtyNum = q('.reviv-sticky__qty-num', bar);
    var elAtc = q('.reviv-sticky__atc', bar);
    var qtyBtns = bar.querySelectorAll('[data-reviv-qty]');

    /* --- mirror price (variant changes update the native price) ----------- */
    function priceText(node) {
      if (!node) return '';
      var money = node.querySelector('.money') || node;
      var t = (money.textContent || '').trim();
      if (!t && money.getAttribute) t = (money.getAttribute('data-current-value') || '').trim();
      return t;
    }
    function mirrorPrice() {
      var pt = priceText(els.currentPrice);
      if (!pt) return; // keep the Liquid-rendered price as fallback
      elPrice.textContent = pt;
    }
    mirrorPrice();
    if (els.priceBlock) {
      var mT;
      try {
        new MutationObserver(function () { clearTimeout(mT); mT = setTimeout(mirrorPrice, 50); })
          .observe(els.priceBlock, { subtree: true, childList: true, characterData: true });
      } catch (e) {}
    }

    /* --- quantity two-way sync -------------------------------------------- */
    function readQty() {
      var v = parseInt(els.qty && els.qty.value, 10);
      return (isNaN(v) || v < 1) ? 1 : v;
    }
    function minQty() {
      var m = parseInt(els.qty && els.qty.getAttribute('min'), 10);
      return (isNaN(m) || m < 1) ? 1 : m;
    }
    function reflectToSticky() { elQtyNum.textContent = String(readQty()); }
    function reflectAfter() { setTimeout(reflectToSticky, 0); }

    function stepQty(delta) {
      if (!els.qty) return;
      if (delta > 0 && els.qtyPlus) { els.qtyPlus.click(); reflectAfter(); return; }
      if (delta < 0 && els.qtyMinus) { els.qtyMinus.click(); reflectAfter(); return; }
      els.qty.value = String(Math.max(minQty(), readQty() + delta));
      els.qty.dispatchEvent(new Event('input', { bubbles: true }));
      els.qty.dispatchEvent(new Event('change', { bubbles: true }));
      reflectToSticky();
    }

    for (var i = 0; i < qtyBtns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          stepQty(parseInt(btn.getAttribute('data-reviv-qty'), 10));
        });
      })(qtyBtns[i]);
    }
    if (els.qty) {
      els.qty.addEventListener('input', reflectToSticky);
      els.qty.addEventListener('change', reflectToSticky);
      try {
        new MutationObserver(reflectToSticky).observe(els.qty, { attributes: true, attributeFilter: ['value'] });
      } catch (e) {}
    }
    reflectToSticky();

    /* --- show/hide state --------------------------------------------------- */
    var scrolledPast = false; // native ATC has left the TOP of the viewport
    var cartOpen = false;
    var teaserHost = null;
    var teaserSuppressing = false;

    function apply() {
      var shouldShow = scrolledPast && !cartOpen;
      bar.classList.toggle('reviv-sticky--visible', shouldShow);
      setTeaserHidden(shouldShow);
    }

    /* --- add to cart (proxy to native button) ------------------------------ */
    elAtc.addEventListener('click', function () {
      if (elAtc.disabled) return;
      els.atc.click();
      elAtc.disabled = true;
      elAtc.classList.add('reviv-sticky--busy');
      setTimeout(function () {
        elAtc.disabled = false;
        elAtc.classList.remove('reviv-sticky--busy');
      }, 1000);
      var n = 0;
      var iv = setInterval(function () { refreshCartState(); if (++n >= 8) clearInterval(iv); }, 250);
    });

    /* --- Shopify Forms "Sign up!" teaser: hide while bar is visible -------- */
    function teaserHideNode(node) {
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    }
    function teaserShowNode(node) {
      node.style.removeProperty('visibility');
      node.style.removeProperty('pointer-events');
    }
    function eachTeaserNode(host, fn) {
      if (host.shadowRoot) {
        var inner = host.shadowRoot.getElementById('app-embed');
        if (inner) fn(inner);
      }
      fn(host);
    }
    function teaserIsCollapsed(host) {
      var inner = host.shadowRoot ? host.shadowRoot.getElementById('app-embed') : null;
      return !!inner && inner.getAttribute('data-current-step') === 'tease';
    }
    function setTeaserHidden(hide) {
      if (!teaserHost) return;
      teaserSuppressing = true;
      var doHide = hide && teaserIsCollapsed(teaserHost);
      eachTeaserNode(teaserHost, doHide ? teaserHideNode : teaserShowNode);
      teaserSuppressing = false;
    }

    (function startTeaserToggle() {
      function findHost() { return document.querySelector('shopify-forms-embed'); }
      function attach(host) {
        teaserHost = host;
        try {
          var mo = new MutationObserver(function () {
            if (teaserSuppressing) return;
            setTeaserHidden(bar.classList.contains('reviv-sticky--visible'));
          });
          mo.observe(host.shadowRoot || host, {
            subtree: true, attributes: true,
            attributeFilter: ['style', 'class', 'data-position', 'data-current-step']
          });
        } catch (e) {}
        setTeaserHidden(bar.classList.contains('reviv-sticky--visible'));
      }
      var existing = findHost();
      if (existing) { attach(existing); return; }
      var tries = 0;
      var iv = setInterval(function () {
        var host = findHost();
        if (host) { clearInterval(iv); attach(host); }
        else if (++tries > 75) clearInterval(iv);
      }, 200);
    })();

    /* --- direction-aware scroll detection ---------------------------------- */
    // Show ONLY when the anchor's bottom scrolled above the viewport top.
    var anchor = els.anchor;
    function computePast() {
      var r = anchor.getBoundingClientRect();
      scrolledPast = (r.bottom <= 8);
    }

    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function () { computePast(); apply(); }, { threshold: [0, 0.01, 1] }).observe(anchor);
      var tick = false;
      window.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        window.requestAnimationFrame(function () { computePast(); apply(); tick = false; });
      }, { passive: true });
      computePast();
      apply();
    } else if (anchor) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { computePast(); apply(); ticking = false; });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    } else {
      scrolledPast = true;
    }

    /* --- cart-open detection (hide bar while the cart drawer is open) ------ */
    var CART_HINT_SELECTORS = [
      '.Drawer--fromRight', '.dv-custom-cart', '.c_cart_drawer_overlay',
      '.cart-drawer', '#sidebar-cart', '.cart__inner', '.cart__wrapper'
    ];

    function detectCartOpen() {
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var s = 0; s < CART_HINT_SELECTORS.length; s++) {
        var nodes = qa(CART_HINT_SELECTORS[s]);
        for (var j = 0; j < nodes.length; j++) {
          var el = nodes[j];
          if (el === bar || el.tagName === 'BUTTON') continue;
          if (!isVisible(el)) continue;
          var cs; try { cs = window.getComputedStyle(el); } catch (e) { cs = null; }
          var pos = cs ? cs.position : '';
          if (!(pos === 'fixed' || pos === 'absolute' || pos === 'sticky')) continue;
          var r = el.getBoundingClientRect();
          var onScreen = r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
          var sizable = r.width > vw * 0.3 && r.height > vh * 0.25;
          if (onScreen && sizable) return true;
        }
      }
      return false;
    }

    function refreshCartState() {
      var now = detectCartOpen();
      if (now !== cartOpen) { cartOpen = now; apply(); }
    }
    refreshCartState();

    try {
      var cartObs = new MutationObserver(function () {
        if (cartObs._t) return;
        cartObs._t = window.requestAnimationFrame(function () { cartObs._t = 0; refreshCartState(); });
      });
      cartObs.observe(document.body, {
        subtree: true, childList: true,
        attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'data-state']
      });
    } catch (e) {}

    document.addEventListener('click', function () {
      setTimeout(refreshCartState, 50);
      setTimeout(refreshCartState, 400);
    }, true);

    apply();
  }
})();





































































// REV|PP|AB19 - sticky bar: interaction/logic only. No markup is created here.
// Markup -> ab19-sticky-bar.liquid | Styles -> ab19-sticky-bar.css
// 1) Keeps the bar price in sync with #reviv-order-total (qty / pack / add-ons).
(function () {
  'use strict';

  var bar = document.getElementById('reviv-sticky-bar');
  if (!bar) return;
  var priceEl = bar.querySelector('.ab19-price');

  if (window.__ab19Obs) { try { window.__ab19Obs.disconnect(); } catch (e) {} }

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function amount(s) { var n = parseFloat(String(s).replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }

  /* ---------- Price sync ---------- */
  function syncPrice(total) {
    var saleText = text(total.querySelector('.reviv-order-sale'));
    var cmpNode = total.querySelector('.reviv-order-compare');
    var cmpText = (cmpNode && !cmpNode.hasAttribute('hidden')) ? text(cmpNode) : '';
    if (cmpText) {
      var a = amount(cmpText), b = amount(saleText);
      if (cmpText === saleText || (a !== null && b !== null && a <= b)) cmpText = '';
    }
    var cmpOut = priceEl.querySelector('.ab19-price__compare');
    var saleOut = priceEl.querySelector('.ab19-price__sale');
    var cmpValue = cmpOut.querySelector('.ab19-price__value');
    var saleValue = saleOut.querySelector('.ab19-price__value');
    var saleSr = saleOut.querySelector('.ab19-sr');

    if (saleText && saleValue.textContent !== saleText) saleValue.textContent = saleText;
    if (cmpValue.textContent !== cmpText) cmpValue.textContent = cmpText;
    cmpOut.hidden = !cmpText;
    saleSr.hidden = !cmpText;
  }

  function initPrice() {
    if (!priceEl) return;
    var total = document.getElementById('reviv-order-total');
    if (!total || !total.querySelector('.reviv-order-sale')) {
      // No live total: show native price instead of the Liquid one.
      priceEl.hidden = true;
      bar.classList.remove('ab19-has-price');
      return;
    }
    syncPrice(total);

    // Throttle, not debounce: the theme rewrites #reviv-order-total constantly.
    var pending = 0;
    window.__ab19Obs = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = 0; syncPrice(total); }, 60);
    });
    window.__ab19Obs.observe(total, {
      childList: true, characterData: true, subtree: true,
      attributes: true, attributeFilter: ['hidden', 'style']
    });
  }

  initPrice();
})();